import script from "./NewReleases.vue?vue&type=script&setup=true&lang=js"
export * from "./NewReleases.vue?vue&type=script&setup=true&lang=js"

import "./NewReleases.vue?vue&type=style&index=0&id=0f99932c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f99932c"]])

export default __exports__